import { DealData } from './DealIdRenderer.types';
import CopyToClipboardCellRenderer from '../CopyToClipboardCellRenderer';

const DealIdRenderer: React.FC<
  DealData & { preTruncateId?: boolean; configEnabledLineLevelTrading?: boolean; isDSMEnvironment?: boolean }
> = ({ data, preTruncateId = false, configEnabledLineLevelTrading = false, isDSMEnvironment = false }) => {
  if (!data?.dealId) return null;

  const dealIdModified = preTruncateId
    ? `${data.dealId.slice(0, 5)}..${data.dealId.slice(data.dealId.length - 10, data.dealId.length)}`
    : data.dealId;

  const getColors = (): string => {
    if (isDSMEnvironment) return 'hover:bg-purple-100';

    if (data.enableLineLevelTrading && configEnabledLineLevelTrading) {
      if (data.isChildRow) return 'hover:bg-primary-300 text-primary-600';
      return 'text-essential-tertiary hover:bg-gray-300';
    }

    if (data.isChildRow) return 'text-essential-tertiary hover:bg-gray-300';
    return 'hover:bg-primary-300 text-primary-600';
  };

  return <CopyToClipboardCellRenderer value={data.dealId} displayValue={dealIdModified} colorClasses={getColors()} />;
};

export default DealIdRenderer;
